import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-ui',
  templateUrl: './chat-history.component.html',
  styleUrls: ['./chat-history.component.scss']
})
export class ChatUiComponent implements OnInit {
  @Input() chatMessages: { User: string; Message: string; SendTime: string }[] = [];

   groupedMessages: any[] = [];

  ngOnInit(): void {
    this.groupMessagesByDate();
  }

  ngOnChanges(): void {
    this.groupMessagesByDate();
  }

  // Group messages by date
  groupMessagesByDate() {
    this.groupedMessages = [];
    let lastDate = '';

    this.chatMessages?.forEach(msg => {
      const msgDate = new Date(msg?.SendTime).toDateString();
      if (msgDate !== lastDate) {
        this.groupedMessages.push({ type: 'date', date: msgDate });
        lastDate = msgDate;
      }
      this.groupedMessages.push({ type: 'message', ...msg });
    });
  }

  getFormattedTime(sendTime: string): string {
    const date = new Date(sendTime);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
    getFileName(path: string): string {
    if (!path) return '';
    const parts = path.split('/');
    return parts[parts.length - 1]; // last part (file name)
  }
}